// Centralized media catalog — every image and video is attributed.
// Direct upload URLs from Wikimedia Commons; CC BY-SA 4.0 unless noted.

export interface MediaImage {
  id: string;
  url: string;
  width?: number;
  height?: number;
  caption: string;
  credit: string;
  license: string;
  sourceUrl: string;
}

export const IMAGES: Record<string, MediaImage> = {
  // ─── Kontinuität (Frankfurt, Max Bill + Stroobant) ───
  'kont-1': {
    id: 'kont-1',
    url: '/img/424d22-kontinuitaet-1986-max-bill-2012-ffm-849.webp',
    width: 4410,
    height: 3192,
    caption: 'Kontinuität (Max Bill + Stroobant, 1986). 80 tons of Rosa Sardo granite, Taunusanlage, Frankfurt.',
    credit: 'Photo: Dontworry',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Kontinuitaet-1986-Max-Bill-2012-Ffm-849.jpg',
  },
  'kont-2': {
    id: 'kont-2',
    url: '/img/6a0397-kontinuitaet-1986-max-bill-2012-ffm-990.webp',
    caption: 'Kontinuität — the polished Möbius loop in front of the Deutsche Bank towers.',
    credit: 'Photo: Dontworry',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Kontinuitaet-1986-Max-Bill-2012-Ffm-990.jpg',
  },
  'kont-3': {
    id: 'kont-3',
    url: '/img/1daafc-ffm-sculpture-kontinuitaet-2012-max-bill-1986-1.webp',
    caption: 'The sculpture in its current Taunusanlage setting after the 2008/2011 relocations.',
    credit: 'Photo: Eva K.',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:FFM_Sculpture_Kontinuitaet_2012_Max_Bill_1986_1.jpg',
  },
  'kont-4': {
    id: 'kont-4',
    url: '/img/6d450e-max-bill-kontinuitaet.webp',
    caption: 'Detail. The polish keeps the high-density Sardinian granite reading as a single soft form.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Max_Bill_Kontinuitaet.jpg',
  },

  // ─── Miseglia (his village) ───
  'miseglia-house': {
    id: 'miseglia-house',
    url: '/img/3978a6-libreria-casa-stroobant-miseglia.webp',
    caption: 'Inside the Stroobant house in Miseglia — his own bookshelves.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Libreria_Casa_Stroobant_Miseglia.jpg',
  },
  'miseglia-1': {
    id: 'miseglia-1',
    url: '/img/41bd97-2017-05-28-via-fantiscritti-con-chiesa-spirito-s.webp',
    caption: 'Via Fantiscritti, Miseglia. His studio Stylithos is at № 11, near the church.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:2017-05-28_via_Fantiscritti_con_Chiesa_Spirito_Santo_Miseglia_01.jpg',
  },
  'miseglia-2': {
    id: 'miseglia-2',
    url: '/img/64388d-2017-05-28-via-fantiscritti-con-chiesa-spirito-s.webp',
    caption: 'Miseglia village — Santo Spirito church, originally 14th-century, reconstructed 1617.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:2017-05-28_via_Fantiscritti_con_Chiesa_Spirito_Santo_Miseglia_02.jpg',
  },
  'fantiscritti': {
    id: 'fantiscritti',
    url: '/img/babcc7-la-cava-di-marmo-fantiscritti-panoramio.webp',
    caption: 'Canale di Fantiscritti — the Roman-era marble quarry just above his house.',
    credit: 'Via panoramio',
    license: 'CC BY-SA 3.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:La_cava_di_marmo_fantiscritti_-_panoramio.jpg',
  },

  // ─── Carrara marble landscape (broader context) ───
  'carrara-land-1': {
    id: 'carrara-land-1',
    url: '/img/6c6fa8-marmorlandschaft-bei-carrara-01.webp',
    caption: 'Marmorlandschaft — the marble landscape of the Apuan Alps above Carrara.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:%22Marmorlandschaft%22_bei_Carrara._01.jpg',
  },
  'carrara-fossacava': {
    id: 'carrara-fossacava',
    url: '/img/075c3d-carrara-colonnata-veduta-di-fossacava-cava-roman.webp',
    caption: 'Fossacava, Colonnata — a Roman quarry in continuous use since the 1st century BC.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Carrara,_colonnata,_veduta_di_fossacava,_cava_romana_in_uso_fin_dal_I_secolo_ac.,_00.jpg',
  },
  'carrara-quarry-face': {
    id: 'carrara-quarry-face',
    url: '/img/ab0890-carrara-marble-quarry-face.webp',
    caption: 'A quarry face inside the Carrara basin.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Carrara_marble_quarry_face.jpg',
  },
  'carrara-marble-caves': {
    id: 'carrara-marble-caves',
    url: '/img/8d22b8-marble-caves-49606300321.webp',
    caption: 'Marble caves — the tunnel quarries he works among.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 2.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Marble_caves._(49606300321).jpg',
  },
  'carrara-bell-towers': {
    id: 'carrara-bell-towers',
    url: '/img/95c503-cava-dei-campanili-bell-towers-quarry-apuan-alps.webp',
    caption: 'Cava dei Campanili — the "Bell Towers Quarry" in the Apuan Alps.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Cava_dei_Campanili_(Bell_Towers_Quarry),_Apuan_Alps.jpg',
  },

  // ─── Bois du Cazier (Marcinelle memorial site) ───
  'bois-1': {
    id: 'bois-1',
    url: '/img/38dde8-bois-du-cazier-3.webp',
    caption: 'Bois du Cazier, Marcinelle — the coal-mine site of the 8 August 1956 disaster, where 262 miners died. UNESCO World Heritage since 2012. Stroobant carved a memorial here in 1988.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Bois_du_Cazier_3.jpg',
  },
  'bois-headframes': {
    id: 'bois-headframes',
    url: '/img/0f1de0-panorama-depuis-le-terril-du-site-du-bois-du-caz.webp',
    caption: 'Panorama from the slag-heap — the preserved headframes of the Bois du Cazier mine.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Panorama_depuis_le_terril_du_site_du_Bois_du_Cazier.jpg',
  },

  // ─── His own sculpture: Marcinelle memorial ───
  'marcinelle-memorial': {
    id: 'marcinelle-memorial',
    url: '/img/faba3b-monument-d-di-aux-victimes-de-bois-du-cazier.webp',
    caption: 'Stroobant\'s 1988 memorial sculpture at Bois du Cazier — dedicated to the 262 miners killed in the 1956 disaster. One of his rare solo public monuments.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Monument_d%C3%A9di%C3%A9_aux_victimes_de_Bois_du_Cazier.JPG',
  },
  // ─── Stroobant himself ───
  'stroobant-2002': {
    id: 'stroobant-2002',
    url: '/img/5fb067-2002-dominique-stroobant.webp',
    caption: 'Dominique Stroobant, 2002.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:2002-Dominique_Stroobant.JPG',
  },
  'stroobant-portrait': {
    id: 'stroobant-portrait',
    url: '/img/c6569f-stroobant-dominique.webp',
    caption: 'Dominique Stroobant in his workshop.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Stroobant_Dominique.JPG',
  },

  // ─── Portraits of named people ───
  'max-bill': {
    id: 'max-bill',
    url: '/img/e803a2-com-l19-0188-0203a.webp',
    caption: 'Max Bill (1908–1994) — Swiss architect, sculptor and designer; Stroobant carved his Kontinuität, 1983–86.',
    credit: 'ETH-Bibliothek Zürich',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Com_L19-0188-0203A.jpg',
  },
  // ─── Solargraph (sun-path) reference images ───
  'solargraph': {
    id: 'solargraph',
    url: '/img/096219-solari117p.webp',
    caption: 'Solargraph — sun paths between July 2018 and May 2019, Valladolid. The kind of image Stroobant pioneered with his 1977 heliographs.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Solari117p.jpg',
  },
  'solargraph-eso': {
    id: 'solargraph-eso',
    url: '/img/bc1ada-when-the-sun-draws-in-the-sky-potw2311a.webp',
    caption: 'A six-month solargraph from ESO\'s APEX site, Chile — the same technique scaled up for astronomy.',
    credit: 'ESO / R. Bergerot',
    license: 'CC BY 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:When_the_Sun_draws_in_the_Sky_(potw2311a).jpg',
  },
  'solargraph-can': {
    id: 'solargraph-can',
    url: '/img/c50187-fotografia0346.webp',
    caption: 'A solargraph camera — a tin can with a pinhole. Stroobant\'s self-built cameras worked on the same principle, but with stacked litho-film sheets.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Fotografia0346.jpg',
  },
  // Geometry / Möbius / hyperbolic paraboloid — illustrations for method steps
  'mobius-strip': {
    id: 'mobius-strip',
    url: '/img/15cd36-m-bius-strip.webp',
    caption: 'A paper Möbius strip. The same topology Max Bill scaled up to a granite monolith.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:M%C3%B6bius_Strip.jpg',
  },
  'hyperbolic-paraboloid': {
    id: 'hyperbolic-paraboloid',
    url: '/img/f7809d-hyperbolic-paraboloid-quadric.webp',
    caption: 'A hyperbolic paraboloid — a curved surface generated by the motion of a single straight line. The basic geometry behind Stroobant\'s diamond-wire cuts.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Hyperbolic_Paraboloid_Quadric.png',
  },
  // Venues that come up across the timeline
  'palazzo-fortuny': {
    id: 'palazzo-fortuny',
    url: '/img/9234b3-palazzo-fortuny-gi-pesaro-orfei.webp',
    caption: 'Palazzo Fortuny (Pesaro Orfei), Venice. The home of Axel Vervoordt\'s curatorial cycle — six of his shows from 2007 to 2017 included Stroobant.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Palazzo_Fortuny,_gi%C3%A0_Pesaro_Orfei.jpg',
  },
  'santa-maria-scala': {
    id: 'santa-maria-scala',
    url: '/img/652c58-facade-santa-maria-della-scala.webp',
    caption: 'Santa Maria della Scala, Siena. Hosted Italy\'s first international pinhole-photography exhibition, Senza Obiettivo, in 2002 — Stroobant built a 3×3 m camera obscura for it.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA 4.0',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Facade_Santa_Maria_della_Scala.jpg',
  },
  'lake-suwa': {
    id: 'lake-suwa',
    url: '/img/405c56-lake-suwa-as-seen-from-tateishi-park-east.webp',
    caption: 'Lake Suwa, Nagano. Site of the 1978 international stone-sculpture symposium — his only documented Japan trip.',
    credit: 'Wikimedia Commons',
    license: 'CC BY-SA',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Lake_Suwa_as_seen_from_Tateishi_Park_(east).jpg',
  },
  'villard': {
    id: 'villard',
    url: '/img/f72819-villard-de-honnecourt.webp',
    caption: 'A page from the Villard de Honnecourt portfolio (c. 1230). Stroobant and Roland Bechmann co-organised didactic exhibitions on the medieval architect\'s notebook in Carrara (2002) and Genoa (2004).',
    credit: 'Bibliothèque nationale de France',
    license: 'Public Domain',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Villard_de_Honnecourt.jpg',
  },
  'ferrer': {
    id: 'ferrer',
    url: '/img/a520f6-francisco-ferrer-guardia.webp',
    caption: 'Francisco Ferrer i Guàrdia (1859–1909) — Catalan anarchist pedagogue, founder of the Modern School. Shot at Montjuïc Castle, 13 October 1909.',
    credit: 'Public domain',
    license: 'Public Domain',
    sourceUrl: 'https://commons.wikimedia.org/wiki/File:Francisco_Ferrer_Guardia.jpg',
  },
};

export interface VideoEmbed {
  id: string;
  youtubeId: string;
  title: string;
  caption: string;
  duration?: string;
}

export const VIDEOS: VideoEmbed[] = [
  {
    id: 'morabito-full',
    youtubeId: '7qdxg8Sj85E',
    title: "Non son l'uno per cento — Anarchici a Carrara (full documentary)",
    caption: "Antonio Morabito's 2006 documentary in which Stroobant is one of five interview subjects. 75 min. Two years and 40 hours of filming with a single digital camera.",
    duration: '75 min',
  },
  {
    id: 'morabito-trailer',
    youtubeId: 'rMUCOkAV0AA',
    title: "Non son l'uno per cento — trailer",
    caption: 'Trailer for the same documentary.',
    duration: '2 min',
  },
  {
    id: 'vervoordt-sfera',
    youtubeId: 'Kwx__fJwfkI',
    title: "La Sfera Schiacciata III — Axel Vervoordt at Art Brussels 2020",
    caption: "Boris Vervoordt presenting Stroobant's *La Sfera Schiacciata III* at Art Brussels 2020.",
  },
];

export const STROOBANT_YOUTUBE_CHANNEL = {
  url: 'https://www.youtube.com/user/1972dominique',
  handle: '@1972dominique',
  note: 'Stroobant\'s own YouTube channel — the handle is his Floating Stones founding year.',
};

// ─── Source citations registry ───
// Every fact in the app can carry a citation key. Use <SourceCite cite="vervoordt-pdf" /> inline.

export interface SourceRef {
  id: string;
  short: string;
  full: string;
  url: string;
  kind: 'wikipedia' | 'gallery' | 'journal' | 'archive' | 'museum' | 'blog' | 'doc' | 'wikidata';
}

export const SOURCES_REGISTRY: Record<string, SourceRef> = {
  'wiki-en': {
    id: 'wiki-en',
    short: 'Wikipedia EN',
    full: 'Wikipedia — Dominique Stroobant',
    url: 'https://en.wikipedia.org/wiki/Dominique_Stroobant',
    kind: 'wikipedia',
  },
  'wiki-it': {
    id: 'wiki-it',
    short: 'Wikipedia IT',
    full: 'Wikipedia (Italian) — Dominique Stroobant',
    url: 'https://it.wikipedia.org/wiki/Dominique_Stroobant',
    kind: 'wikipedia',
  },
  'wiki-miseglia': {
    id: 'wiki-miseglia',
    short: 'Wikipedia — Miseglia',
    full: 'Wikipedia — Miseglia',
    url: 'https://en.wikipedia.org/wiki/Miseglia',
    kind: 'wikipedia',
  },
  'wiki-kont-de': {
    id: 'wiki-kont-de',
    short: 'Wikipedia DE — Kontinuität',
    full: 'Wikipedia (German) — Kontinuität (Skulptur)',
    url: 'https://de.wikipedia.org/wiki/Kontinuit%C3%A4t_(Skulptur)',
    kind: 'wikipedia',
  },
  'wiki-marcinelle': {
    id: 'wiki-marcinelle',
    short: 'Wikipedia — Marcinelle',
    full: 'Wikipedia — Marcinelle mining disaster',
    url: 'https://en.wikipedia.org/wiki/Marcinelle_mining_disaster',
    kind: 'wikipedia',
  },
  'wiki-fai': {
    id: 'wiki-fai',
    short: 'Wikipedia — FAI',
    full: 'Wikipedia — Italian Anarchist Federation',
    url: 'https://en.wikipedia.org/wiki/Italian_Anarchist_Federation',
    kind: 'wikipedia',
  },
  'wikidata': {
    id: 'wikidata',
    short: 'Wikidata Q22236316',
    full: 'Wikidata — Dominique Stroobant (Q22236316)',
    url: 'https://www.wikidata.org/wiki/Q22236316',
    kind: 'wikidata',
  },
  'vervoordt-pdf': {
    id: 'vervoordt-pdf',
    short: 'Vervoordt bio PDF (OCR)',
    full: "Axel Vervoordt Gallery — Stroobant biographical PDF (OCR'd locally)",
    url: 'https://axel-vervoordt.s3.amazonaws.com/documents/DOMINIQUE_STROOBANT_BIO-website.pdf',
    kind: 'gallery',
  },
  'vervoordt-artist': {
    id: 'vervoordt-artist',
    short: 'Vervoordt artist page',
    full: 'Axel Vervoordt Gallery — Dominique Stroobant artist page',
    url: 'https://www.axel-vervoordt.com/gallery/artists/dominique-stroobant',
    kind: 'gallery',
  },
  'fischer-1999': {
    id: 'fischer-1999',
    short: 'Fischer 1999',
    full: 'Gerd Fischer, "Der Koloss von Frankfurt: die Kontinuität von Max Bill", DMV-Mitteilungen 4/1999, pp. 22–23.',
    url: 'https://www.degruyterbrill.com/document/doi/10.1515/dmvm-1999-0410/pdf',
    kind: 'journal',
  },
  'welt-form': {
    id: 'welt-form',
    short: 'Welt der Form',
    full: 'Welt der Form — records on Bill\'s Kontinuität',
    url: 'https://welt-der-form.net/Rekorde/30-Bill-1986-Kontinuitaet.html',
    kind: 'archive',
  },
  'museo-bozzetti': {
    id: 'museo-bozzetti',
    short: 'Museo dei Bozzetti',
    full: 'Museo dei Bozzetti, Pietrasanta — STYLITHOS studio record',
    url: 'http://www.museodeibozzetti.it/assets/files/mdb/collezione/laboratori/s001283.php',
    kind: 'museum',
  },
  'leitch-2007': {
    id: 'leitch-2007',
    short: 'Leitch 2007',
    full: 'Alison Leitch, "Visualizing the mountain: the photographer as ethnographer in the marble quarries of Carrara", Journal of Modern Italian Studies (2007).',
    url: 'https://www.tandfonline.com/doi/abs/10.1080/13545710701282379',
    kind: 'journal',
  },
  'leitch-2010': {
    id: 'leitch-2010',
    short: 'Leitch 2010',
    full: 'Alison Leitch, "Materiality of Marble: Explorations in the Artistic Life of Stone", Thesis Eleven (Dec 2010).',
    url: 'https://journals.sagepub.com/doi/10.1177/0725513610381370',
    kind: 'journal',
  },
  'ferretti-2022': {
    id: 'ferretti-2022',
    short: 'Ferretti 2022',
    full: 'F. Ferretti, "Statues that must stand not fall: the material agency of anarchism in the marble monuments of Carrara, Italy", Journal of Historical Geography (2022).',
    url: 'https://www.sciencedirect.com/science/article/pii/S0305748822000779',
    kind: 'journal',
  },
  'obscura-history': {
    id: 'obscura-history',
    short: 'Obscura Photography',
    full: 'Obscura Photography — History of pinhole photography',
    url: 'https://obscura-photography.co.uk/history',
    kind: 'archive',
  },
  'alt-photo': {
    id: 'alt-photo',
    short: 'AlternativePhotography',
    full: 'AlternativePhotography — Solarigraphy: from its origin until today',
    url: 'https://www.alternativephotography.com/solarigraphy/',
    kind: 'archive',
  },
  'pinhole-resource': {
    id: 'pinhole-resource',
    short: 'Pinhole Resource',
    full: 'Pinhole Resource — Pinhole Journal back issues (Vol. 17 #1, 2001 dedicated to Stroobant)',
    url: 'https://pinholeresource.com/pinhole-journal-55-back-issues/',
    kind: 'archive',
  },
  'tirreno-2012': {
    id: 'tirreno-2012',
    short: 'Il Tirreno 2012',
    full: 'Il Tirreno Massa-Carrara, 13 Aug 2012: "Così ho scolpito i morti di Marcinelle"',
    url: 'https://iltirreno.gelocal.it/massa/cronaca/2012/08/13/news/cosi-ho-scolpito-i-morti-di-marcinelle-1.5543047',
    kind: 'journal',
  },
  'antwerp-public-art': {
    id: 'antwerp-public-art',
    short: 'Antwerps Persbureau',
    full: 'Antwerps Persbureau — Lapis Arte / Stroom Maatwerk on the Antwerp public art collection',
    url: 'https://antwerpspersbureau.be/lapis-arte-en-stroom-maatwerk-onderhouden-260-kunstwerken-in-heel-de-stad/',
    kind: 'blog',
  },
  'krogt-ferrer': {
    id: 'krogt-ferrer',
    short: 'Statues — Van der Krogt',
    full: 'Statues — Hither and Thither: Ferrer monument record',
    url: 'https://statues.vanderkrogt.net/object.php?webpage=ST&record=itto131',
    kind: 'archive',
  },
  'iscum-villard': {
    id: 'iscum-villard',
    short: 'ISCUM Villard',
    full: 'ISCUM — Villard de Honnecourt e i modi di costruire',
    url: 'https://www.iscum.it/villard-de-honnecourt-e-i-modi-di-costruire/',
    kind: 'museum',
  },
  'morabito-doc': {
    id: 'morabito-doc',
    short: 'Morabito doc 2006',
    full: "Non son l'uno per cento — Anarchici a Carrara (Antonio Morabito, 2006). Documentary, 75 min.",
    url: 'https://www.youtube.com/watch?v=7qdxg8Sj85E',
    kind: 'doc',
  },
  'middelheim': {
    id: 'middelheim',
    short: 'Middelheim Museum',
    full: 'Middelheim Open-Air Sculpture Museum — Antwerp',
    url: 'https://middelheimmuseum.be/en',
    kind: 'museum',
  },
  'mhka': {
    id: 'mhka',
    short: 'M HKA',
    full: 'M HKA — Museum van Hedendaagse Kunst Antwerpen',
    url: 'https://www.muhka.be/en/',
    kind: 'museum',
  },
  'cdla-kunst': {
    id: 'cdla-kunst',
    short: 'CDLA — Kunstinformatie',
    full: 'Centre du livre d\'artiste — Kunstinformatie listings (Dag in dag uit, 1980)',
    url: 'https://cdla.info/2020/02/28/kunstinformatie/',
    kind: 'archive',
  },
  'unopercento-blog': {
    id: 'unopercento-blog',
    short: 'unopercento.wordpress',
    full: "Non son l'uno per cento — anarchici a Carrara (project blog)",
    url: 'https://unopercento.wordpress.com/',
    kind: 'blog',
  },
  'carrara-marble-tour': {
    id: 'carrara-marble-tour',
    short: 'Anarchic Carrara',
    full: 'Carrara Marble Tour — Anarchic Carrara',
    url: 'https://www.carraramarbletour.it/en/anarchic-carrara/',
    kind: 'blog',
  },
};

export type SourceKey = keyof typeof SOURCES_REGISTRY;
